import { render, staticRenderFns } from "./AudioWavePlayer.vue?vue&type=template&id=41637e5d&scoped=true&"
import script from "./AudioWavePlayer.vue?vue&type=script&lang=js&"
export * from "./AudioWavePlayer.vue?vue&type=script&lang=js&"
import style0 from "./AudioWavePlayer.vue?vue&type=style&index=0&id=41637e5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41637e5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSlider } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VList,
  VListTile,
  VListTileTitle,
  VMenu,
  VSlider,
})
